import { render, staticRenderFns } from "./TestimonialsView.vue?vue&type=template&id=4c4406e8&"
import script from "./TestimonialsView.vue?vue&type=script&lang=js&"
export * from "./TestimonialsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports